import api from "../../../../../api/api"


const importTallyUnits = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("import/tally/stock/units",payload
        ).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const importTallyStockGroups = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("import/tally/stock/groups",payload
        ).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const importTallyGodowns = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("import/tally/stock/godowns",payload
        ).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const importTallyTaxUnits = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("import/tally/stock/tax-units",payload
        ).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const importTallyProducts = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("import/tally/stock/products",payload
        ).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const stockImportServices = {
    importTallyUnits,
    importTallyStockGroups,
    importTallyGodowns,
    importTallyProducts,
    importTallyTaxUnits
}

export default stockImportServices;